/* eslint-disable react/no-children-prop */
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Paper,
  Typography
} from "@material-ui/core";
import { isEmpty } from "lodash";
import React from "react";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import ReactMarkdown from "react-markdown";
import { BaseLayout, Flaticon, SponsorList } from "../components";
import { GetAvailableLinks } from "../features/lib";
import { useCongress, useCongressStyle, useUserMe } from "../hooks";
import { ReactComponent as BadgeScanSvg } from "../assets/icons/badge scan.svg";

const useStyles = makeStyles(theme => ({
  item: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: theme.spacing(3)
  },
  icon: {
    width: "3rem",
    height: "3rem",
    margin: theme.spacing(4),
    fill: theme.palette.primary.main
  }
}));

const HomePage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { congress } = useCongress();
  const { user } = useUserMe();
  const intl = useIntl();
  const extraLinks = [];
  if (user?.hasRoles(["assistant"])) {
    extraLinks.push({
      label: intl.formatMessage({ id: "Pages.HomePage.BadgeScan", defaultMessage: "Badge Scan" }),
      icon: BadgeScanSvg,
      route: "/physical_rooms",
      featureName: "my_badge"
    });
  }

  const links = GetAvailableLinks(extraLinks);
  const congressClasses = useCongressStyle()();

  const onRouteClick =
    ({ route }) =>
    () => {
      history.push(route);
    };

  return (
    <BaseLayout>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "90%" }}
      >
        <Grid container spacing={3}>
          {!isEmpty(congress.welcomeVideoUrl) || !isEmpty(congress.welcomeBody) ? (
            <Grid item md={6} xs={12}>
              <Card className={classes.item}>
                <CardActionArea>
                  {!isEmpty(congress.welcomeVideoUrl) && (
                    <CardMedia
                      className={classes.media}
                      title="Welcome Video"
                      component={ReactPlayer}
                      width="100%"
                      url={congress.welcomeVideoUrl}
                      controls
                    />
                  )}

                  {!isEmpty(congress.welcomeBody) && (
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {congress.welcomeTitle}
                      </Typography>
                      <ReactMarkdown children={congress.welcomeBody} />
                    </CardContent>
                  )}
                </CardActionArea>
              </Card>
            </Grid>
          ) : (
            <Grid item md={3} xs={12} />
          )}

          <Grid container item md={6} xs={12}>
            <Grid container spacing={3}>
              {links.map(({ label, icon: Icon, route }) => (
                <Grid key={route} item md={6} xs={12}>
                  <Paper
                    onClick={onRouteClick({ route })}
                    className={`${classes.item} ${congressClasses.congress}`}
                  >
                    {typeof Icon === "string" ? (
                      <Flaticon icon={Icon} fontSize="3rem" color="primary" margin={4} />
                    ) : (
                      <Icon className={classes.icon} />
                    )}
                    <Typography variant="h4" align="center">
                      <strong>{label}</strong>
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <SponsorList />
          </Grid>
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default HomePage;
